// checkUserPurchaseStatus.js
'use strict';
import fetchMe from '../action/fetchMe.js';
import getMeData from '../selector/getMeData.js';

const POLL_INTERVAL_MS = 5000;
const MAX_POLL_COUNT = 18;

let activeTimerId = null;

const stopPolling = () => {
  if (activeTimerId != null) {
    clearTimeout(activeTimerId);
    activeTimerId = null;
  }
};

/**
 * Poll `fetchMe` as a fallback for the pusher purchase events
 *
 * Only one polling loop runs at a time; calling again cancels the
 * previous loop, so `loadUrlOrderProcessing`'s call automatically
 * supersedes any polling left behind by `submitCompleteOrder`.
 * @kind action
 * @returns {Promise} Action promise.
 */
const checkUserPurchaseStatus = () => async (dispatch, getState) => {
  stopPolling();

  let pollCount = 0;

  const tick = async () => {
    activeTimerId = null;
    await dispatch(fetchMe({ isForceFetch: true }));
    pollCount += 1;
    const lastPurchased = getMeData(getState(), 'lastPurchased');
    if (pollCount >= MAX_POLL_COUNT || lastPurchased) {
      return;
    }
    activeTimerId = setTimeout(tick, POLL_INTERVAL_MS);
  };

  activeTimerId = setTimeout(tick, POLL_INTERVAL_MS);
  return { type: '' };
};

export default checkUserPurchaseStatus;
